import storageFactory from '../utils/storageFactory';

export const local = storageFactory(localStorage);
export const session = storageFactory(sessionStorage);
